import { getSnapMenuLineItem } from 'containers/Snaps/Snap/lib';
import { ISnapStore, updateSnapLineItemsSuccessAction } from 'containers/Snaps/Snap/store';

import { getFormattedDataWithScores, removeItemFromArray, replaceItemInArray } from 'utils';

import { CreateLineItemRequest, DeleteResponse, SnapDetailsLineItem } from 'codegen';
import {
  IDataResponse,
  InitialTableActions,
  TRequestCallback,
} from 'types';

export const handlePatchLineItem = (
  onPatchTableData: TRequestCallback<SnapDetailsLineItem>,
) => (
  record: SnapDetailsLineItem,
  actionType?: InitialTableActions,
) => {
  const payload = getFormattedDataWithScores(record);
  const isApprove = actionType === InitialTableActions.Approve;

  onPatchTableData({
    payload,
    callbackURL: `/snaps/details/items/${record.id}`,
    callbackQueryParams: { isApprove },
  });
};

export const handleSuccessPatchLineItem = (
  dataSource: ISnapStore['lineItems'],
) => (
  { data }: IDataResponse<SnapDetailsLineItem>,
) => {
  const newData = replaceItemInArray(dataSource, data);

  updateSnapLineItemsSuccessAction({ lineItems: newData });
};

export const handlePostLineItem = (
  onPostTableData: TRequestCallback<CreateLineItemRequest>,
  snapId?: string,
) => (
  record: SnapDetailsLineItem,
) => {
  const payload = { snapId: Number(snapId), ...record };

  onPostTableData({ payload });
};

export const handleSuccessPostLineItem = (
  dataSource: ISnapStore['lineItems'],
) => (
  { data }: IDataResponse<SnapDetailsLineItem>,
) => {
  const lineItems = [...dataSource, data];

  updateSnapLineItemsSuccessAction({
    lineItems,
    lineItemOptions: lineItems.map(getSnapMenuLineItem),
  });
};

export const handleDeleteLineItem = (
  onDeleteTableData: TRequestCallback,
  snapId?: string,
) => (
  id: number,
) => {
  onDeleteTableData({ callbackURL: `/snaps/details/${snapId}/items/${id}` });
};

export const handleSuccessDeleteLineItem = (
  lineItems: ISnapStore['lineItems'],
  lineItemOptions: ISnapStore['lineItemOptions'],
) => (
  { data }: IDataResponse<DeleteResponse>,
) => {
  updateSnapLineItemsSuccessAction({
    lineItems: removeItemFromArray({ data: lineItems, value: data.id }),
    lineItemOptions: removeItemFromArray({ data: lineItemOptions, key: 'value', value: data.id }),
  });
};
